import { LocationDescriptor } from 'history';
import React from 'react';
import { Link } from 'react-router-dom';

import { TruncatedText } from './TruncatedText';

export interface TruncatedLinkTextProps {
	text: string | null;
	to: LocationDescriptor;
	className: string;
	textClassName?: string;
	/** Clamp to two lines instead of a single-line ellipsis. */
	multiline?: boolean;
	testId?: string;
	tabIndex?: number;
}

export function TruncatedLinkText({
	text,
	to,
	className,
	textClassName,
	multiline = false,
	testId,
	tabIndex,
}: TruncatedLinkTextProps) {
	const value = text ?? '';

	// An empty cell still needs the link, a row click can land on it.
	if (value === '') {
		return <Link className={className} data-testid={testId} tabIndex={tabIndex} to={to} />;
	}

	return (
		<TruncatedText
			text={value}
			className={textClassName}
			truncateClassName={multiline ? 'line-clamp-2 whitespace-normal' : undefined}
			tooltipWidthClass='w-max max-w-xs'
			portal
			alwaysShowTooltip
			renderReference={(reference) => (
				<Link className={className} data-testid={testId} tabIndex={tabIndex} to={to}>
					{reference}
				</Link>
			)}
		/>
	);
}
